import { publicEnv } from "@/config/env";
import ProductsList from "@/features/products/components/product-list/product-list";
import { HeroMarkdownSection } from "@/features/shared/components/hero-markdown-section-client";
import { HeroMarkdownSkeleton } from "@/features/shared/components/hero-markdown-skeleton";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { useLng } from "@/hooks/use-lng";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_app/products/")({
  head: () => appTitleHead("products"),
  component: ProductsPage
});

function ProductsPage() {
  const lng = useLng();

  if (publicEnv.USE_PRODUCT === "false") {
    return <NotFoundPage />;
  }

  return (
    <div className="w-full">
      <Suspense fallback={<HeroMarkdownSkeleton />}>
        <HeroMarkdownSection lng={lng} section="products" />
      </Suspense>
      <ProductsList />
    </div>
  );
}
